import {Component, computed, inject} from '@angular/core';
import {ActivatedRoute, NavigationEnd, Router, RouterLink, RouterLinkActive, RouterOutlet} from "@angular/router";
import {EditorialsIconComponent} from "../../../../components/icons/editorials-icon/editorials-icon.component";
import {toSignal} from "@angular/core/rxjs-interop";
import {filter} from "rxjs";

@Component({
  selector: 'wun-configurator',
  standalone: true,
  imports: [
    RouterOutlet,
    EditorialsIconComponent,
    RouterLinkActive,
    RouterLink
  ],
  templateUrl: './configurator.component.html',
  styleUrl: './configurator.component.scss'
})
export class ConfiguratorComponent {

  private readonly activatedRoute = inject(ActivatedRoute);
  private readonly router = inject(Router)
  private readonly navigationEnd = toSignal(this.router.events.pipe(filter(d => d instanceof NavigationEnd)));
  routeName = computed(() => {
    this.navigationEnd();
    return this.router.url.includes('slides') ? 'Slides' : 'Exhibitions'
  })

}
